module.exports = __webpack_public_path__ + "img/objetivos_onu.a117fc7b.webp";